<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      إسناد {{ data.title }}
      @if (data.subtitle) {
      <span class="subtitle">ل شركة {{ data.subtitle }}</span>
      }
    </h2>
  </div>

  <div mat-dialog-content>
    <div class="client-values">
      <p class="font-12 client-input-label font-semibold mb-2">مدخلات العميل:</p>
      <p class="font-16 font-bold">{{ data?.value?.length > 0 ? data?.value : '-' }}</p>
    </div>

    <!-- ng-select with pagination -->
    <div class="select-container">
      <ng-select #assigneeSelect [items]="assigneeList" bindLabel="name" bindValue="id" appendTo="body"
        [(ngModel)]="selectedAssignee" [loading]="isLoading" [searchable]="true" [clearable]="false"
        placeholder="اختر {{ data.title }}" notFoundText="لا توجد نتائج" [virtualScroll]="true"
        (scrollToEnd)="onScroll()" (search)="onSearch($event)" (clear)="resetSearch()">
        <ng-template ng-option-tmp let-item="item">
          <div class="option-content">
            {{ item.name }}
          </div>
        </ng-template>
      </ng-select>
    </div>

    @if (errorMessage) {
    <div class="error-state mt-2">
      <p>{{ errorMessage }}</p>
    </div>
    }
  </div>

  <div mat-dialog-actions class="actions-double">
    <app-action-button (submitAction)="save($event)" [disabled]="!selectedAssignee || isLoading"
      label="تأكيد الإسناد"></app-action-button>
    <button class="btn btn-cancel" mat-dialog-close>إلغاء</button>
  </div>
</div>
